export function Divider() {
  return <div className="h-0.5 bg-blue-grey-200" />;
}
